import { useRef, useEffect } from 'react'

export function useIsInitialMount () {
  const isInitialMount = useRef(true)

  useEffect(() => {
    isInitialMount.current = false
  }, [])

  return isInitialMount.current
}
